import React from "react";
import ReactDOM from "react-dom";
import App from "./Apps";
import 'bootstrap/dist/css/bootstrap.min.css';


const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(
  <div>
<App />
  </div>

);